import ToDos from 'components/admin/ToDos/ToDos.jsx'
import React from 'react'
import { Grid } from 'semantic-ui-react'

export default class ToDosContainer extends React.Component {
  render() {
    return (
      <Grid stackable>
        <Grid.Row columns={2}>
          <Grid.Column tablet={12} computer={12} largeScreen={8} widescreen={6}>
            <ToDos />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/admin/todos.jsx